export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/zoran-profile-85dad82d6ed2b728f219b4b77e15d844.png";